<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-10-10 11:25:13
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-10-10 16:35:20
 * @FilePath: /chaoyongtuan/src/views/cooperativeShop/shopList/components/tableCells/commandCell.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="command-cell">
		<div class="command-cell-content">
			<div>{{ row.institution_name | textFormat(6) }}</div>
			<el-tooltip placement="top" :open-delay="300">
				<div slot="content">
					<span>团长ID</span>
					<span class="ml-4">{{ row.authority_id | formatEmpty }}</span>
					<i class="el-icon-copy-document cursor-pointer ml-4 mt-2 hover" @click="handleCopy(row.authority_id)"></i>
				</div>
				<div class="tag-lable radius-4 ml-4 font-h6-regular yx-color-text-regular cursor-pointer hover">ID</div>
			</el-tooltip>
			<div></div>
		</div>
	</div>
</template>
<script>
import { copy } from '@/utils/common';
import mixin from '@/components/tableCells/mixin';
export default {
	mixins: [mixin],
	data() {
		return {};
	},
	methods: {
		handleCopy(id) {
			copy(id);
			this.$message.success('复制成功');
		},
	},
};
</script>
<style lang="less" scoped>
.command-cell-content {
	display: flex;
	align-items: center;
}
.tag-lable {
	padding: 0 3px;
	height: 17px;
	border-radius: 3px;
	background-color: @color-gy2;
	margin-left: 4px;
}
</style>
